import React from 'react'

function ExclamationIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      fill="#F04438"
      width="21"
      height="21"
      viewBox="0 0 21 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7436 20.08C16.2886 20.08 20.7836 15.5849 20.7836 10.04C20.7836 4.49506 16.2886 0 10.7436 0C5.19867 0 0.703613 4.49506 0.703613 10.04C0.703613 15.5849 5.19867 20.08 10.7436 20.08Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.166 3.59497L11.8445 12.3002H9.02518L8.70368 3.59497H12.166ZM10.4348 16.455C9.95671 16.455 9.54762 16.287 9.20758 15.9511C8.86753 15.6151 8.69957 15.2061 8.70369 14.7238C8.69957 14.2539 8.86753 13.852 9.20758 13.5182C9.54763 13.1843 9.95672 13.0174 10.4348 13.0174C10.8882 13.0174 11.2891 13.1843 11.6374 13.5182C11.9857 13.8521 12.1619 14.2539 12.166 14.7238C12.1619 15.2061 11.9857 15.6152 11.6374 15.9511C11.2891 16.287 10.8882 16.455 10.4348 16.455Z"
        fill="white"
      />
    </svg>
  )
}

export default ExclamationIcon
